module.exports = __webpack_public_path__ + "img/1b3336a.png";